module.exports = __webpack_public_path__ + "fonts/HelveticaNeueLTGEO-85Heavy.d7e4c787.ttf";